import { render } from "./index.vue?vue&type=template&id=54c2667e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=54c2667e&scoped=true&lang=less"

import exportComponent from "/root/workspace/want-ceo-backstage-management/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c2667e"]])

export default __exports__